import React from "react"
import posed from "react-pose"
import styled from "styled-components"
import { getIsVisibleInLocale } from "../../../../services/links"
import breakpoints from "../../../../styles/breakpoints"
import colors from "../../../../styles/colors"
import BlockContainer from "../../BlockContainer"
import ImageGrid from "./ImageGrid"
import LinkList from "./LinkList"
import fonts from "../../../../styles/fonts"

const OverlayContainer = styled.div`
  position: relative;
`

const OverlayAnimated = posed.div({
  desktopNavFrom: {
    height: "0",
    transition: {
      duration: 200,
    },
  },
  desktopNavTo: {
    height: "auto",
    transition: {
      duration: 200,
    },
  },
})

const Overlay = styled(OverlayAnimated)`
  position: absolute;
  top: 0;
  left: 0%;
  width: 100%;
  background: ${colors.beige};
  overflow: hidden;
  height: 0;
`

const OverlayContent = styled.div`
  padding: 30px 0;
`

const Content = styled.div`
  padding: 0 0 0 4px;
  @media (min-width: ${breakpoints.xl}) {
    padding: 0 0 0 10px;
  }
`

const Grid = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: 60px;
`

const LinkListContainer = styled.div`
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
  flex: 1;
  justify-content: flex-start;

  @media (min-width: ${breakpoints.xl}) {
    flex: 1.5;
  }
`

const ImageLinksContainer = styled.div`
  max-width: ${(props) => (props.imageLength === 1 ? "544px" : "670px")};
  flex: 1;
`

const DesktopOverlay = ({
  links,
  activeTab,
  setActiveTab,
  isBespokeOpen,
  setIsBespokeOpen,
}) => {
  const handleBespokePopupClick = () => {
    setActiveTab(null)
    if (!isBespokeOpen) {
      setIsBespokeOpen(true)
    }
  }

  return (
    <OverlayContainer>
      {links.map((list, index) => {
        if (list.__typename === "ContentfulLink") return null

        const isVisible = getIsVisibleInLocale(list.locale)

        if (!isVisible) return null

        const allImageLinks = list.links.every((link) => link.thumbnail)
        const imageLinks = list.links.filter((link) => link.thumbnail)
        const linkLists = list.links.filter((link) => !link.thumbnail)
        return (
          <Overlay
            key={index}
            onMouseOver={() => setActiveTab(list.id)}
            onMouseLeave={() => setActiveTab(null)}
            pose={activeTab === list.id ? "desktopNavTo" : "desktopNavFrom"}
          >
            <OverlayContent>
              <BlockContainer>
                <Content style={{ padding: "0 0 0 10px" }}>
                  {allImageLinks ? (
                    <ImageGrid
                      links={list.links}
                      handleBespokePopupClick={handleBespokePopupClick}
                    />
                  ) : (
                    <Grid>
                      <LinkListContainer>
                        {linkLists.map((item, index) => {
                          const isVisible = getIsVisibleInLocale(item.locale)

                          if (!isVisible) return null

                          return (
                            <LinkList
                              header={item.header}
                              links={item.links}
                              key={index}
                              handleBespokePopupClick={handleBespokePopupClick}
                            />
                          )
                        })}
                      </LinkListContainer>
                      {imageLinks.length > 0 ? (
                        <ImageLinksContainer imageLength={imageLinks.length}>
                          <ImageGrid
                            links={imageLinks}
                            handleBespokePopupClick={handleBespokePopupClick}
                          />
                        </ImageLinksContainer>
                      ) : null}
                    </Grid>
                  )}
                </Content>
              </BlockContainer>
            </OverlayContent>
          </Overlay>
        )
      })}
    </OverlayContainer>
  )
}

export default DesktopOverlay
